// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_header_top-module__container--3ZAUc{margin:15px auto 20px}.lawyer_header_top-module__verifiedIcon--3wvJj{height:16px;margin-left:8px}\n", ""]);
// Exports
exports.locals = {
	"container": "lawyer_header_top-module__container--3ZAUc",
	"verifiedIcon": "lawyer_header_top-module__verifiedIcon--3wvJj"
};
module.exports = exports;
